class Salesforce {
    constructor (element, options) {
        // Default options
        const defaults = {
            initAttr: 'data-salesforce'
        };

        // Settings
        this.settings = Object.assign({}, defaults, options);

        // Elements
        this.$root = element;
        this.$$utmInputs = this.$root.querySelectorAll('input[id^="utm_"]');
    }

    initialize () {
        if (this.$$utmInputs.length > 0) {
            this.setUTMParameters();
        }
    }

    // Parse URL parameter based on input element's ID
    parseGET (input) {
        const searchStr = document.location.search;

        try {
            const match = searchStr.match('[?&]' + input.id + '=([^&]+)');

            if (match) {
                // If found in the URL parameter, set it as the input's value
                let result = match[1];
                result = result.replace(/\+/g, '%20');
                result = decodeURIComponent(result);
                return result;
            } else {
                // If not found in the URL parameter, remove the element from the DOM
                input.remove();
                return '';
            }
        } catch (e) {
            return '';
        }
    }

    // Set UTM parameters for input elements to submit with form
    setUTMParameters () {
        this.$$utmInputs.forEach($utmInput => {
            $utmInput.value = this.parseGET($utmInput);
        });
    }
}

export { Salesforce };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$salesforce = $context.querySelectorAll('[data-salesforce="root"]');
        for (let i = 0; i < $$salesforce.length; i++) {
            const $salesforce = $$salesforce[i];

            const $salesforceAPI = new Salesforce($salesforce);
            $salesforceAPI.initialize();
        }
    }
});
